'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  background-color: transparent;\n  border: none;\n  :hover {\n    color: gold;\n  }\n'], ['\n  color: ', ';\n  background-color: transparent;\n  border: none;\n  :hover {\n    color: gold;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _tooltip = require('../tooltip/tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.button(_templateObject, function (props) {
  return props.color;
});

/** @class AddToShowbagButton
  * A button to manage adding and removing
  * content from the visitor's showbag.
  * @prop {Object} content - the content to add to the showbag
  */

var AddToShowbagButton = function (_Component) {
  _inherits(AddToShowbagButton, _Component);

  /** @constructor
    * Creates a new instance of AddToShowbagButton
    * for the specified content, and determines
    * if the content is already in the showbag.
    */
  function AddToShowbagButton(props) {
    _classCallCheck(this, AddToShowbagButton);

    var _this = _possibleConstructorReturn(this, (AddToShowbagButton.__proto__ || Object.getPrototypeOf(AddToShowbagButton)).call(this, props));

    _this.state = {
      inBag: window.vexpo.showbag.includes(props.content)
    };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Event handler for adding or removing the content
    * from the showbag.
    */


  _createClass(AddToShowbagButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _this2 = this;

      if (this.state.inBag) {
        window.vexpo.showbag.remove(this.props.content).then(function () {
          return _this2.setState({ inBag: false });
        });
      } else {
        window.vexpo.showbag.add(this.props.content).then(function () {
          return _this2.setState({ inBag: true });
        });
      }
    }
    /** @method render
      * Renders the AddToShowbagButton with the
      * appropriate message for if the button will
      * add or remove the content from the showbag.
      */

  }, {
    key: 'render',
    value: function render() {
      var message = this.state.inBag ? "Remove From Favorites" : "Add To Favorites";
      var color = this.state.inBag ? "orange" : "orange";
      var star = this.state.inBag ? "star" : "star-o";
      return _react2.default.createElement(
        _tooltip2.default,
        { text: message },
        _react2.default.createElement(
          Button,
          { color: color, onClick: this.handleClick },
          _react2.default.createElement(_reactFontawesome2.default, { name: star, size: '2x' })
        )
      );
    }
  }]);

  return AddToShowbagButton;
}(_react.Component);

exports.default = AddToShowbagButton;


AddToShowbagButton.propTypes = {
  content: _propTypes2.default.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/add-to-showbag-button.js
// module id = 1328
// module chunks = 0